import { useMutation } from "@tanstack/react-query";
import apiClient from "lib/api-client";
import config from "configs/config";

const deleteUSPDesign = async (payload) => {
  const response = await apiClient.post(`${config.baseUrl}/api/v1/styles/removeUSPDesign`, payload);
  return response.data;
};

export const useDeleteUSPDesign = () => {
  return useMutation({
    mutationFn: deleteUSPDesign,
  });
};
